export const CASH_ACCOUNTS_ITEMS_PER_PAGE = 10;

export const INITIAL_CASH_ACCOUNT_FORM = {
  uuid: null,
  name: '',
  currency: 'ARS',
  initial_balance: '0',
  exchange_rate_to_ars: '',
  current_balance: '0',
  is_active: true,
};

export const CASH_ACCOUNT_DRAWER_TABS = {
  data: 'data',
  status: 'status',
};
